import React from 'react';
import PropTypes from 'prop-types';

import {
  COPPER,
  CORE,
  PREPREG,
} from '../../../constants/globals';
import FormFrame from '../../common/FormFrame';
import Material from '../../../models/Material';
import EditCopperForm from './EditCopperForm';
import EditCoreForm from './EditCoreForm';
import EditPrepregForm from './EditPrepregForm';

export const EditLayerComponent = (props) => {
  const { layer, layers, mirror, lengthUnit, onCancel, onSubmit } = props;
  const title = layer.toString(lengthUnit);
  const forms = {
    [COPPER]: EditCopperForm,
    [CORE]: EditCoreForm,
    [PREPREG]: EditPrepregForm,
  }
  const Form = forms[layer.type];

  return (
    <FormFrame label={title}>
      <Form
        layer={layer}
        layers={layers}
        mirror={mirror}
        onCancel={onCancel}
        onSubmit={onSubmit}
        lengthUnit={lengthUnit}
      />
    </FormFrame>
  );
}

EditLayerComponent.propTypes = {
  layer:      PropTypes.instanceOf(Material).isRequired,
  layers:     PropTypes.arrayOf(PropTypes.instanceOf(Material)).isRequired,
  mirror:     PropTypes.instanceOf(Material).isRequired,
  onCancel:   PropTypes.func.isRequired,
  onSubmit:   PropTypes.func.isRequired,
  lengthUnit: PropTypes.string.isRequired,
};

export default EditLayerComponent;


// WEBPACK FOOTER //
// ./src/components/StackupDesign/EditLayer/EditLayerComponent.js